<!-- src/app/shared/error/error.component.html -->
<div class="error">
  {{ message }}
</div>
